/** Align with Hub list: deleted Biz from fetchHubs API */
export function isDeletedBiz(store) {
  const v = (store?.ActiveFlag ?? store?.activeFlag ?? "").toString().toUpperCase();
  return v === "DELETED";
}
